import React from 'react';

import { Button, ButtonGroup, Modal } from '@sine/sine-ui-components';

interface PromptModalProps {
  title: string;
  content: React.ReactNode;
  show: boolean;
  discardButtonText?: string;
  continueButtonText?: string;
  onDiscard: () => void;
  onContinue: () => void;
}

export default function PromptModal({
  title,
  content,
  show,
  discardButtonText = 'Discard changes',
  continueButtonText = 'Continue editing',
  onDiscard,
  onContinue,
}: PromptModalProps) {
  return (
    <Modal
      header={title}
      show={show}
      size='xs'
      onClose={onContinue}
      footer={
        <ButtonGroup alignment='right'>
          <Button variant='tertiary' onClick={onDiscard}>
            {discardButtonText}
          </Button>
          <Button variant='primary' onClick={onContinue}>
            {continueButtonText}
          </Button>
        </ButtonGroup>
      }
    >
      {content}
    </Modal>
  );
}
